import React, { useState, useEffect } from "react";
import "./TextRoller.css";

const TextRoller = ({ messages }) => {


    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % messages.length);
        }, 2000); // change every 2s
        return () => clearInterval(timer);
    }, [messages.length]);

    return (
        <div className="text-roller">
            <div
                className="roller"
                style={{ transform: `translateY(-${index * 30}px)` }}
            >
                {messages.map((msg, i) => (
                    <span key={i}>{msg}</span>
                ))}
            </div>
        </div>
    );
};

export default TextRoller;
